import { BaseResponse } from "api/common";
import createInstance from "../util";
import { GridOrderCurrentParam } from "./index";

let commonInstance2 = createInstance("/v1/trigger/strategy");
let commonInstance = createInstance("/v1/trigger/strategy/dca");
let platFormInstance = createInstance("/v1/strategyPlatform/public");
type configParam = {
  businessLine: number | string;
  symbolId: string;
  dcaType?: number; //正向dca或者反向dca
};
/**
 * DCA策略配置查询
 * https://yapi.cointr.me/project/44/interface/api/10073
 */
export const getDcaConfig = (params: configParam) => {
  return commonInstance2.post("/config/dca", params);
};

// type confirmDataParam = appendCountParam & {
//     maxAppendCount: number // 最大补单词书
//     marginMode: number // 当前持仓模式
//     tokenId: string // 保证金币种
// }

type appendCountParam = {
  appendType: string; // 1 首单开仓均价 2 上一笔开仓均价
  investType: string; // 投入类型 1 市价 2 限价
  targetLoss: number; // 止损，百分比
  businessLine: number; // 业务线ID
  targetProfit: number; // 目标盈利,百分比
  dcaType: number; // 1正向网格 2反向网格
  leverage: number; // 杠杆
  priceTimes: number; // 补单价格间隔倍数
  firstChangeRange: number; //首单补单价格下跌/上涨幅度 正数为涨，负数为跌
  firstPrice: number; // 首单下单价格,市价单时，将实时价格填充到此字段中
  firstAmount: number; // 首单金额
  amountTimes: number; // 补单金额倍数
  investTokens: Object;
  profitType: number; //
  symbolId: string; //
};

type createStrategyParam = appendCountParam & {
  endOperate: number; // 1.全部撤单 2.撤单平仓
};
/**
 * 获取提交参数确认
 * https://yapi.cointr.me/project/44/interface/api/10075
 */
export const getConfirmData = (params: createStrategyParam): Promise<any> => {
  return commonInstance.post("/confirmParam", params);
};

/**
 * 创建DCA策略
 * https://yapi.cointr.me/project/44/interface/api/10076
 */
export const createPlaceStrategyDca = (params: createStrategyParam) => {
  return commonInstance.post("/placeStrategyDca", params);
};

type fastStrategyParam = {
  businessLine: number;
  symbolId: number | string;
};
/**
 * 创建快捷DCA策略
 * https://yapi.cointr.me/project/44/interface/api/10076
 */
export const createFastPlaceStrategyDca = (params: fastStrategyParam) => {
  return commonInstance.post("/fastCreateStrategy", params);
};

type updateStrategyParam = {
  targetLoss: number;
  symbolId: number | string;
  targetProfit: number;
  endOperate: number;
  marginMode: number;
  strategyId: string;
  businessLine: string | number;
};
/**
 * 更新DCA策略
 * https://yapi.cointr.me/project/44/interface/api/10076
 */
export const updateStrategy = (params: Partial<updateStrategyParam>) => {
  return commonInstance.post("/updateStrategy", params);
};

/**
 * 获取历史策略列表
 * @param params
 * @returns {Promise<{}>}
 */
export function getStrategyHistoryList(params: GridOrderCurrentParam) {
  return commonInstance.post("/query/strategyHistoryList", params);
}

type orderListParam = {
  strategyId: string;
  businessLine: string | number;
  strategyFlag: string | number;
  isPre: number;
  pageSize: number;
  lastEndId: number;
};
/**
 * 策略订单接口
 */
export const getOrderList = (params: orderListParam) => {
  // strategyCurrentList
  return commonInstance2.post("/common/query/strategyOrderList", params);
};

/**
 * 查询列表配置接口
 */
export const historyListConfig = () => {
  return commonInstance2.post("/common/config");
};

/**
 * 查询dca循环次数
 */

export const getDcaLoopTimes = (params: {
  businessLine: number;
  strategyId: string;
}) => {
  return commonInstance.post("/query/trackingList", params);
};
/**
 * 策略订单接口
 */
export function getStrategyOrderList(params: {
  businessLine: number;
  strategyId: string;
  strategyFlag: number;
  pageSize: number;
  pageNo: number;
  strategyType: number;
  gridType?: number;
}) {
  return commonInstance2.post("/common/query/strategyOrderList", params);
}

/**
 * 获取"正在执行"数据
 * @param params
 * @returns {Promise<unknown>}
 */
export function trackingListCurrent(
  params: { strategyId: string; businessLine: number },
  instance?: typeof commonInstance2
) {
  const getRequestInstance = instance || commonInstance2;
  return getRequestInstance.post("/query/trackingListCurrent", params);
}

/**
 * 查询ai策略列表
 * https://yapi.sniper5.vip/project/53/interface/api/37268
 * @params
 */

type aiStrategyProps = {
  symbolId: string;
  secondStrategyType?: number | string; // 仅App选择方向后使用 策略类型 1:正向网格 2: 反向网格 3:多头网格 4: 空头网格 5:正向DCA 6:反向DCA 7:多头DCA 8:空头DCA  10: 正向CTA 11:多头CTA 12:空头CTA
  strategyType: number | string; // 一级策略类型  1:现货网格 2:合约网格  3:现货DCA. 4: 合约DCA. 15:现货CTA 16:合约CTA
  aiType?: number; // CTA专用 ai类型  4: macd  5: 布林带  全部不传
  backtestTime?: any;
  type?: number | string; //1 收益率排序    2：使用人数排序 默认不传
};
export const getAiStrategyList = (params: aiStrategyProps) => {
  return platFormInstance.post("/ai/selectAiStrategyList", params);
};

/**
 * AI列表（包含跟单策略）
 * https://yapi.sniper5.vip/project/53/interface/api/82971
 * @params
 */

type aiStrategyRecommendProps = {
  symbolId?: string; // 交易币对
  type?: number; // 1 收益率排序    2：使用人数排序 默认不传
  strategyType: number; // 一级策略类型  1:现货网格 2:合约网格  3:现货DCA. 4: 合约DCA
};
export const getAiStrategyRecommendList = (
  params: aiStrategyRecommendProps
) => {
  return platFormInstance.post("/ai/selectAiRecommendList", params);
};

/**
 * CTA-AI策略列表查询
 * CTA策略AI列表因为数据兼容，要使用新接口，yapi文档已维护。
 * https://yapi.sniper5.vip/project/53/interface/api/72371
 */
export const getSelectCtaList = (params: aiStrategyProps) => {
  return platFormInstance.post("/ai/selectCtaList", params);
};

/**
 * 选取的策略查询参数
 */
export const getSelectStrategyData = (parmas: { id: number }): Promise<any> => {
  return platFormInstance.post("/ai/queryPlaceParam", parmas);
};

interface getCurrentDCaCompletedListParams {
  businessLine: number;
  strategyId: number;
  pageSize: number; // 每页条数：默认20，最多20条
  lastEndId: number; // 上次查询结果最后id,分页基于这个继续向后查
  isPre: boolean; // 是否是查询上一页  默认 false
}

/**
 * dca 当前策略已完成列表
 */
export const getCurrentDCaCompletedList = (
  params: getCurrentDCaCompletedListParams
) => {
  return commonInstance2.post("/dca/query/trackingList", params);
};

interface getDcaTrackingDetailOrdersPrams {
  currentLoopTimes: string;
  strategyId: string;
}

/**
 * DCA一次循环订单详情
 */
export const getDcaTrackingDetailOrders = (
  params: getDcaTrackingDetailOrdersPrams
) => {
  return commonInstance2.post("/dca/query/trackingDetailOrders", params);
};

interface getCurrentDCaRunningListParams {
  businessLine: number;
  strategyId: number;
}

/**
 * dca 当前策略正在执行列表
 */
export const getCurrentDCaRunningList = (
  params: getCurrentDCaRunningListParams
) => {
  return commonInstance2.post("/dca/query/trackingListCurrent", params);
};

interface getUpdateStopConditionParams {
  strategyId: string;
  stopPrice: string; //1为保证金,2为利润
}

/**
 * dca 修改终止条件
 */
export const updateStopCondition = (params: getUpdateStopConditionParams) => {
  return commonInstance2.post("/dca/updateStopCondition", params);
};

interface investTokensTypes {
  USDT?: string;
  baseCount?: string;
}
export interface DycExpandDcaParams {
  strategyId: string;
  type: number; //类型:1.增加保证金 2.增加铺单保证金  3.增加补单次数 4.加仓 5.减仓
  investToken: any;
  orderCount?: number; //次数 增加的订单数量
  handleCount?: number | string; //减仓的数量
}
/**
 * DCA动态扩展（追加资金/订单/手动加减仓） https://yapi.sniper5.vip/project/44/interface/api/82575
 */
export const DycExpandDcaFun = (params: DycExpandDcaParams) => {
  return commonInstance2.post("/dca/dycExpandDca", params);
};

interface GetExpandMinAmountParams {
  strategyId: string;
  type: number; //类型:1.增加保证金 2.增加铺单保证金  3.增加补单次数 4.加仓 5.减仓
  orderCount?: number; //次数 增加的订单数量
}

/**
 * 追加最小投资额查询
 */
export const getExpandMinAmountFun = (params: GetExpandMinAmountParams) => {
  return commonInstance2.post("/dca/getExpandMinAmount", params);
};

/**
 * 扩展配置读取
 */
export const queryExpandConfigFun = (params: GetExpandMinAmountParams) => {
  return commonInstance2.post("/dca/queryExpandConfig", params);
};

interface UdateTriggerIndicatorRequest {
  businessLine: number; // 业务线
  strategyId: string; // 策略ID
  triggerIndicator?: number; // 触发条件 1上次循环平仓均价、2 RSI、3 BOLL
  indicatorLength?: number; // 标长度(1-100，前端默认20)、
  triggerThreshold?: number; // 触发阈值(1-100,前端默认 正向/多头=30，反向/空头=70)
  kLineCycle?: number; // K线周期 单位分钟 (1m 3m 5m 30m 1H 4H 1D)
  multiply?: number; // 布林带指标乘数（多元）// 由后端返给前端，如果有值，前端不可更改，如果是空，则可以更改
  investType?: number; // 投入类型 1 市价 2 限价
  triggerPrice?: string;
}
export const updateTriggerIndicator = (
  params: UdateTriggerIndicatorRequest
) => {
  return commonInstance2.post<BaseResponse<{ result: boolean }>>(
    "/dca/updateTriggerIndicator",
    params
  );
};
